import styled from 'styled-components';

import { MOBILE_DOCUMENT_HEIGHT } from '../../constants';

export const DocCard = styled.section`
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.common.white};
  overflow: hidden;

  /* The page (not the container) scrolls on mobile, so give the card a bounded height to keep
     the document body internally scrollable — that's what drives the read-to-end detection. */
  @media (max-width: 768px) {
    height: ${MOBILE_DOCUMENT_HEIGHT};
  }
`;

export const DocHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px 8px;
  flex-shrink: 0;
`;

export const ProgressLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ProgressPercent = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const ProgressTrack = styled.div`
  height: 4px;
  margin: 0 20px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.grey[200]};
  flex-shrink: 0;
  overflow: hidden;
`;

export const ProgressBar = styled.div<{ $percent: number }>`
  height: 100%;
  width: ${({ $percent }) => $percent}%;
  border-radius: 2px;
  background-color: ${({ theme, $percent }) =>
    $percent >= 100 ? theme.palette.success.main : theme.palette.primary.main};
  transition: width 0.15s ease-out, background-color 0.15s ease-out;
`;

export const DocBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px 32px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
